var React = require('react');

function DauerInline (props) {
    return React.createElement("g",props,[React.createElement("path",{"d":"M7.99333333,1.33333333 C4.31333333,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.31333333,14.6666667 7.99333333,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 7.99333333,1.33333333 Z","id":"Shape","fill":"#BFD107","key":0}),React.createElement("polygon",{"id":"Path","fill":"#000000","points":"8.33333333 4.66666667 7.33333333 4.66666667 7.33333333 8.66666667 10.8333333 10.7666667 11.3333333 9.94666667 8.33333333 8.16666667","key":1})]);
}

DauerInline.defaultProps = {"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = DauerInline;

DauerInline.default = DauerInline;
